const header = document.querySelector('.javtec-header');

if (header) {
  const syncMegaState = () => {
    const isOpen = Boolean(header.querySelector('.menu-list__link[aria-expanded="true"] + .menu-list__submenu .javtec-mega-menu'));
    header.toggleAttribute('data-javtec-mega-open', isOpen);
  };

  const observer = new MutationObserver(syncMegaState);

  header.querySelectorAll('.menu-list__link[aria-haspopup="true"]').forEach((link) => {
    observer.observe(link, { attributes: true, attributeFilter: ['aria-expanded'] });
  });

  header.addEventListener('pointerleave', syncMegaState);
  syncMegaState();
}
